import { forwardRef } from 'react';
import { Overlay } from '@radix-ui/react-dialog';

import { cn } from 'styles';

interface BackgroundProps {
  className?: string;
  id?: string;
}

export const OverlayBackground = forwardRef(({ className, ...props }: BackgroundProps, ref) => (
  <Overlay
    {...props}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref={ref as any}
    className={cn(
      'fixed inset-0 z-50 bg-black/80 dark:bg-black/60',
      'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      className,
    )}
  />
));

OverlayBackground.displayName = 'OverlayBackground';
